import React from 'react';

import { Box, Typography } from '@mui/material';

import useAssignAccounts from '../../../../hooks/Admin/AdminList/useAssignAccounts';
import CustomTableBack from '../../../common/CustomTableBack';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import AssignAccountsTransferList from './AssignAccountsTransferList';
import styles from './styles';

const AssignAccounts = () => {
  const { list, setList, userName, showConfirmation, setSearch } = useAssignAccounts();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.backContainer}>
        <CustomTableBack backLabel={strings.administrators} />
      </Box>
      <Typography sx={styles.title}>{strings.assignAccounts}</Typography>
      <Typography sx={styles.subtitle}>{userName}</Typography>

      <AssignAccountsTransferList
        list={list}
        setList={setList}
        setSearch={setSearch}
      />

      <Box sx={styles.buttonContainer}>
        <CustomButton
          label={strings.assign}
          onClick={showConfirmation}
          customClass={styles.buttonSize}
        />
      </Box>
    </Box>
  );
};

export default AssignAccounts;
